import { getMomentTz } from "@dexteel/mesf-core";

import { MechanicalTestRunDisposition } from "../../models/MechanicalTestRunDisposition";
import { Disposition } from "./types";

const moment = getMomentTz();

export const getSampleStatusLabel = (code: Disposition) => {
	switch (code) {
		case "P":
			return { label: "Passed", color: "success" as const };
		case "R":
			return { label: "ReTest", color: "warning" as const };
		case "U":
			return { label: "Unknown", color: "default" as const };
	}
};

export const formatMechanicalValue = (
	value: number | null,
	passed: boolean | null,
	min: number | null,
	max: number | null,
	decimals?: number,
	minCompare: number | null = min,
	maxCompare: number | null = max,
) => {
	if (value == null) return "-";
	const display =
		decimals != null ? parseFloat(value.toFixed(decimals)) : value;
	if (passed !== false) return display;

	if (minCompare != null && value < minCompare)
		return `${display} (Min: ${min})`;
	if (maxCompare != null && value > maxCompare)
		return `${display} (Max: ${max})`;
	return `${display}`;
};

const trimNumber = (value: number) => String(Number(value.toFixed(3)));

export const formatRange = (
	min: number | null | undefined,
	max: number | null | undefined,
	unit?: string | null,
) => {
	const suffix = unit ? ` ${unit}` : "";
	if (min != null && max != null)
		return `${trimNumber(min)} - ${trimNumber(max)}${suffix}`;
	if (min != null) return `≥ ${trimNumber(min)}${suffix}`;
	if (max != null) return `≤ ${trimNumber(max)}${suffix}`;
	return "-";
};

export const formatTimestamp = (timestamp: Date | null | undefined) =>
	timestamp ? moment(timestamp).format("MM/DD/YY HH:mm") : "-";

export const disposedByLabel = (
	disposition: MechanicalTestRunDisposition | null,
) => {
	if (!disposition) return "-";
	return disposition.DisposedBy?.trim().toLowerCase() === "auto"
		? "Auto"
		: disposition.DisposedBy;
};
